/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeleteChatExportDataDto } from './DeleteChatExportDataDto';
import {
    DeleteChatExportDataDtoFromJSON,
    DeleteChatExportDataDtoFromJSONTyped,
    DeleteChatExportDataDtoToJSON,
    DeleteChatExportDataDtoToJSONTyped,
} from './DeleteChatExportDataDto';

/**
 * 
 * @export
 * @interface DeleteChatExportResponseDto
 */
export interface DeleteChatExportResponseDto {
    /**
     * Result message
     * @type {string}
     * @memberof DeleteChatExportResponseDto
     */
    message: string;
    /**
     * 
     * @type {DeleteChatExportDataDto}
     * @memberof DeleteChatExportResponseDto
     */
    data: DeleteChatExportDataDto;
}

/**
 * Check if a given object implements the DeleteChatExportResponseDto interface.
 */
export function instanceOfDeleteChatExportResponseDto(value: object): value is DeleteChatExportResponseDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function DeleteChatExportResponseDtoFromJSON(json: any): DeleteChatExportResponseDto {
    return DeleteChatExportResponseDtoFromJSONTyped(json, false);
}

export function DeleteChatExportResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteChatExportResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'data': DeleteChatExportDataDtoFromJSON(json['data']),
    };
}

export function DeleteChatExportResponseDtoToJSON(json: any): DeleteChatExportResponseDto {
    return DeleteChatExportResponseDtoToJSONTyped(json, false);
}

export function DeleteChatExportResponseDtoToJSONTyped(value?: DeleteChatExportResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'data': DeleteChatExportDataDtoToJSON(value['data']),
    };
}

